<script lang="ts">
import { PopperWrapper } from 'floating-vue';

export default {
  ...PopperWrapper,
  name: 'ATooltip',
  vPopperTheme: 'atlasti-tooltip',
};
</script>
<style lang="scss">
@use 'settings/colors';
@use 'settings/settings';

.v-popper__popper.v-popper--theme-atlasti-tooltip {
  z-index: settings.$tooltip-z-index;

  // this is off by one pixel in the floating-vue css for some reason
  &[data-popper-placement^='right'] .v-popper__arrow-outer {
    left: -5px;
  }

  .v-popper__inner {
    font-size: 14px;
    background: colors.$color-grey-800;
    color: colors.$color-white;
    border-radius: 8px;
    padding: 8px 16px;
    z-index: 2;
  }
}
</style>
